import type {ListOfferTemplatesSearchInput} from "./list-offer-templates.schema";
import {listOfferTemplates} from "@project/sdk/sales";
import {ListOfferTemplatesResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";
import {assertOfferTemplatePreview} from "../../../offerTemplate-read";
import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {offerTemplateKeys} from "../../../offerTemplate-keys";
import {listOfferTemplatesSearchSchema} from "./list-offer-templates.schema";

export function listOfferTemplatesQueryOptions(rawInput: ListOfferTemplatesSearchInput) {
  const params = listOfferTemplatesSearchSchema.parse(rawInput);
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: offerTemplateKeys.list(params),
    queryFn: async ({signal}) => {
      const response = await listOfferTemplates(params, {signal});
      const parsed = ListOfferTemplatesResponse.parse(response);
      parsed.items.forEach((item, index) =>
        assertOfferTemplatePreview(item, response.items[index]),
      );
      return parsed;
    },
  });
}
